import { Media } from 'ca-api-client';
import { mediaFilters } from '@/filters/media';

export default class SelectMedia {
    config() {
        return {
            title: 'Select Media',
            description: 'Select a media item below.',
            mode: 'multiple',
            media: true,
            sets: false,
            upload: {
                allow: true,
                allowMultiple: false,
                newVersion: false,
                newThumbnail: false,
                allowedFileTypes: ['image', 'document', 'video', 'audio', 'other'],
                onProcessFile: this.processFile,
            },
            defaultFilters: [
                { type: 'image,video,document,before_after,audio,other' },
                { interactive_id: null },
                { 360: null },
                { public: null },
            ],
            filterOptions: mediaFilters,
        };
    }
    processFile(file) {
        // no scope here
        return new Promise((resolve) => {
            const serverJson = JSON.parse(file.serverId).data;
            serverJson.url = file.getFileEncodeDataURL();
            const serverData = new Media(serverJson);

            App.$store.dispatch('prependGalleryMediaSelectItem', serverData).then(() => {
                App.$store.commit('setMediaSelectModalCurrentView', 'MediaSelect');
                resolve(serverData);
            });
        }).catch((error) => {
            console.log(error);
        });
    }
    doAction() {
        console.log('SelectMedia::doAction()');
        return new Promise((resolve, reject) => {
            const items = App.$store.getters.getMediaSelectSelected;
            if (items) {
                resolve(items);
            } else {
                reject('Could not find specified media item.');
            }
        }).catch((error) => {
            reject(error);
            console.log(error);
        });
    }
}
